<script>
  import Modal from "./../../../shared/Modal.svelte";
  import CreateStyleForm from "../../FStyles/CreateStyleForm.svelte";
  import FStylesReusable from "../../FStyles/FStylesReusable.svelte";

  export let orderID;
  export let orderNumber;
  export let customerID;

  let showAddNewStyleForm = false;
</script>

<Modal
  show={showAddNewStyleForm}
  on:modalClose={() => (showAddNewStyleForm = false)}
  xxl
>
  <CreateStyleForm
    {orderID}
    {orderNumber}
    on:productCreated={() => (showAddNewStyleForm = false)}
  />
</Modal>

<div class="grid grid-cols-1 gap-4">
  <button
    class="btn btn-primary"
    on:click={(e) => (showAddNewStyleForm = true)}
    style="width: 100%;"
  >
    <i class="fas fa-plus-circle mr-3" />
    Create Product for this Job Card 🆕
  </button>
</div>

<!-- POPULATE DATA HERE -->
<div class="py-2" />
<FStylesReusable EDITABLE={true} {orderID} {customerID} />
